import React from "react";
import Calendar from "../Calendar/Calendar";

export default function DateTimeInput({
  label,
  value,
  setValue,
  setUIValue,
  disabled,
  validate,
}) {
  return (
    <Calendar
      type="datetime-local"
      value={value}
      setValue={(e) => {
        if (!e.target.value) {
          setValue("");
          setUIValue("");
          return;
        }
        const date = new Date(e.target.value);

        let dateDD = date.getDate();
        let dateMM = date.getMonth() + 1;
        let dateYYYY = date.getFullYear();
        if (dateDD < 10) dateDD = "0" + dateDD;
        if (dateMM < 10) dateMM = "0" + dateMM;

        let hh = date.getHours();
        let mm = date.getMinutes();
        if (hh < 10) hh = "0" + hh;
        if (mm < 10) mm = "0" + mm;

        const today = `${dateYYYY}-${dateMM}-${dateDD}T${hh}:${mm}`;

        setValue(today);
        setUIValue(e.target.value);
      }}
      label={label}
      disabled={disabled}
      validate={validate}
    />
  );
}
